import styled from "@emotion/styled";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

export const StyledContentListSkeleton = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}));

export const StyledTopSectionWrapperSkeleton = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
}));
